// A clean placeholder for persona screens whose module has not yet been built (round-2 fan-out fills these).
// Keeps the IA complete + navigable so the persona shell is fully explorable today.
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Construction } from "lucide-react";

export function ModulePlaceholder({ title }: { title?: string }) {
  return (
    <div className="mx-auto max-w-xl py-16">
      <Card>
        <CardHeader className="flex-row items-center gap-3">
          <Construction className="size-6 text-primary" aria-hidden />
          <CardTitle>{title ?? "Module in aanbouw"}</CardTitle>
        </CardHeader>
        <CardContent className="text-sm text-muted-foreground">
          Dit onderdeel wordt in deze bouwronde opgeleverd. De informatiestructuur staat al; het scherm volgt.
        </CardContent>
      </Card>
    </div>
  );
}
